/* eslint-disable import/no-unresolved */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { process } from "@progress/kendo-data-query";
import { Card, CardBody, Flex } from "@chakra-ui/react";
import { FaEdit } from "react-icons/fa";
import Loader from "components/PageLoader";
import VehiclesFilterBarV2 from "components/vehicles/filter-bar";
import { useUser } from "../../hooks/use-user";
import { Paths } from "../../routes/paths";
import { HasPermission } from "../../utils/helper";
import { useGetVehicles } from "../../services/vehicles";
import { initialDataState } from "./constants";
import BreadCrumb from "components/breadCrumb";

export default function VehiclesList() {
  const [vehicles, setVehicles] = useState([]);
  const user = useUser();
  const [dataState, setDataState] = useState(initialDataState);

  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  const pageSize = 25;

  const [filters, setFilters] = useState({
    searchCriteria: "",
    selectedCashCenterId: "",
  });
  const {
    mutate: getVehiclesList,
    isSuccess: vehicleListAvailable,
    data: vehiclesList,
    isPending: gettingVehiclesList,
    // error: vehicleListError,
    reset: resetVehiclesList,
  } = useGetVehicles();

  useEffect(() => {
    if (vehicleListAvailable) {
      setVehicles(vehiclesList.data.data);
      setTotalRecords(vehiclesList.data.totalRecords);
      resetVehiclesList();
    }
  }, [vehicleListAvailable]);

  useEffect(() => {
    setCurrentPage(1);
    getVehiclesList({
      pageNumber: 1,
      pageRowCount: pageSize,
      searchCriteria: filters.searchCriteria,
      operationDate: new Date(),
      cashCenterId: filters.selectedCashCenterId,
    });
  }, [filters]);

  const viewCell = ({ dataItem }) => {
    return (
      <td>
        {canViewDetails ? (
          <Flex
            as={Link}
            to={`${Paths.vehicleDetails}/${dataItem.id || dataItem.vehicleId}`}
            style={{ cursor: "pointer", color: "blue" }}
            title="View Details"
          >
            {dataItem.registrationNo}
          </Flex>
        ) : (
          <Flex>{dataItem.registrationNo}</Flex>
        )}
      </td>
    );
  };
  const editVehicleCell = ({ dataItem }) => {
    if (canEdit) {
      return (
        <td>
          <Flex
            as={Link}
            to={`${Paths.editVehicle}/${dataItem.vehicleId}`}
            justifyContent="center"
            style={{ cursor: "pointer" }}
            w="100%"
            title="Edit Vehicle"
          >
            <FaEdit fontSize="18px" color="var(--primary-dark)" />
          </Flex>
        </td>
      );
    }
    return <td> {dataItem.vehicleId}</td>;
  };

  const onPageChange = (e) => {
    const _page = e.page.skip / pageSize + 1;
    setCurrentPage(_page);
    getVehiclesList({
      pageNumber: _page,
      pageRowCount: pageSize,
      searchCriteria: filters.searchCriteria,
      operationDate: new Date(),
      cashCenterId: filters.selectedCashCenterId,
    });
  };

  const canEdit = useMemo(() => {
    return HasPermission(user, "Vehicle", "Edit");
  }, [user]);
  const canViewDetails = useMemo(() => {
    return HasPermission(user, "Vehicle", "View");
  }, [user]);

  return (
    <Flex className="main-container">
      {gettingVehiclesList ? <Loader /> : <></>}
      <Flex px="20px">
        <BreadCrumb
          links={[
            { text: "Dashboard", link: Paths.dashboard },
            { text: "Vehicles", isCurrentPage: true },
          ]}
        />
      </Flex>
      <Card m="20px">
        <CardBody>
          <VehiclesFilterBarV2
            getList={(filter, cashCenterId) => {
              setFilters({
                searchCriteria: filter,
                selectedCashCenterId: cashCenterId,
              });
            }}
          />
          <Grid
            data={process(vehicles || [], dataState)}
            {...dataState}
            onDataStateChange={(e) => {
              setDataState(e.dataState);
            }}
            filterable
            sortable
            pageable
            total={totalRecords}
            pageSize={pageSize}
            skip={(currentPage - 1) * pageSize}
            onPageChange={onPageChange}
            className="vehicles-list-grid"
          >
            <Column
              field="registrationNo"
              title="Registration No"
              width={180}
              cell={viewCell}
            />
            <Column
              field="registrationType"
              title="Registration Type"
              width={180}
            />
            <Column field="fleetNo" title="Fleet No" width={140} />
            <Column field="cashCenter" title="Cash Center" width={120} />

            <Column field="cashLimit" title="Cash Limit" width={150} />
            {/* <Column field="fitnessDueDate" title="Location Type" width={150} /> */}

            <Column field="issuedTo" title="Issued To" width={120} />
            <Column field="office" title="Office" />

            <Column field="vanType" title="Van Type" width={120} />
            <Column field="status" title="Status" width={120} />
            <Column
              title="Edit"
              filterable={false}
              cell={editVehicleCell}
              width={80}
              headerClassName="text-center"
            />
          </Grid>
        </CardBody>
      </Card>
    </Flex>
  );
}
